export default __webpack_public_path__ + "static/media/unc.7c3b0332.png";